var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-13"},[_c('PdfEditor',{attrs:{"fileInfo":_vm.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }